<!-- Modal LOGIN-->
<div class="modal fade contenedor-modal" id="modalLogin" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0">
        <app-login-form [esModal]="true" (resultEvent)="onLogin($event)" (goRegister)="abrirModal(modalRegister)">
        </app-login-form>
      </div>
    </div>
  </div>
</div>

<!-- Modal REGISTRO-->
<div class="modal fade contenedor-modal" id="modalRegister" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0">
        <app-register-form [esModal]="true" (resultEvent)="onRegister($event)" (goLogin)="abrirModal(modalLogin)">
        </app-register-form>
      </div>
    </div>
  </div>
</div>

<!-- Modal TARJETAS-->
<div class="modal fade contenedor-modal" id="modalPayment" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="objetoPurchase">
      <div class="modal-body p-0">
        <app-payment-options [info]="infoCompra" [typeTransaction]="objetoPurchase.type"
          [objetoPurchase]="objetoPurchase" [ppv]="false"></app-payment-options>
      </div>
    </div>
  </div>
</div>

<!-- Modal CONDICIONES-->
<div class="modal fade contenedor-modal" id="modalConditions" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body p-0">
        <!-- <app-payment-options
          [typeTransaction]="objetoPurchase.type"
          [objetoPurchase]="objetoPurchase"
        ></app-payment-options> -->

        <app-conditions (onClose)="onCondiciones($event)"></app-conditions>
      </div>
    </div>
  </div>
</div>

<!-- ------------------------------------------------------------------------------------------------------------------- -->

<!-- PANTALLA -->
<div class="pantalla clara pt-1 pt-xxl-5">
  <!-- titulo -->
  <div class="row">
    <div class="col-12 text-center mt-3 mt-xxl-3">
      <span class="titulo py-0"> Suscríbete ahora para tener las mejores películas en la palma de tu mano. </span>
    </div>
  </div>

  <!-- tarjetas de planes -->
  <div class="row">
    <div class="col-12 mt-4 mt-xxl-5">
      <div class="row filaPlanes justify-content-center align-items-center">
        <!-- FOR LOOP -->
        <div class="col-12 mb-4 cardPlan" *ngFor="let plan of plans">
          <div class="card p-1 py-3">
            <div class="card-body text-center px-3 pl-xl-5 pr-xl-5 pl-md-4 pr-md-4 py-4" *ngIf="!loading">
              <!-- titulo -->
              <h5 class="font-weight-bold">{{ plan.name }}</h5>

              <!-- lista items de plan -->
              <ul class="list-group text-left mt-4 p-0">
                <li class="list-group-item border-0 px-0">
                  <i class="fas fa-check text-primary mr-4"></i> <strong>{{ plan.texto1 }}</strong>
                </li>

                <li class="list-group-item border-0 px-0">
                  <i class="fas fa-check text-primary mr-4"></i>
                  <strong class="text-wrap">{{ plan.texto2 }}</strong>
                </li>

                <li class="list-group-item border-0 px-0">
                  <i class="fas fa-check text-primary mr-4"></i> <strong class="">{{ plan.texto3 }}</strong>
                </li>

                <li class="list-group-item border-0 px-0">
                  <i class="fas fa-check text-primary mr-4"></i> <strong class="">{{ plan.texto4 }}</strong>
                </li>

                <li class="list-group-item border-0 px-0 listFooter">
                  <strong class="">{{ plan.footer }}</strong>
                </li>
              </ul>

              <!-- boton suscripcion plan mensual-->
              <div class="mt-4 d-flex justify-content-center">
                <button class="subBttn btn btn-primary btn-lg border-0 btn-block" style="color: white !important"
                  (click)="confirmSuscriptionMensual(plan)">
                  Suscripción Mensual ${{plan.price}}
                </button>
              </div>

              <!-- boton suscripcion plan anual -->
              <div class="mt-4 d-flex justify-content-center">
                <button class="subBttn btn btn-primary btn-lg border-0 btn-block" style="color: white !important"
                  (click)="confirmSuscriptionAnual(plan)">
                  Suscripción Anual ${{plan.anualprice}}
                </button>
              </div>

            </div>

            <div class="card-body text-center" *ngIf="loading">
              <div class="spinner-border mt-2 text-secondary" style="width: 1.5rem; height: 1.5rem" role="status"
                *ngIf="loading">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Tarjeta Cupon -->
        <div class="card-body text-center px-3 pl-xl-5 pr-xl-5 pl-md-4 pr-md-4 py-4" *ngIf="!loading">
          <!-- cupon -->
          <div class="row panel-cupon" id="list-cupon">
            <div class="col-12 mb-5 mt-xxl-5">
              <form class="text-center" [formGroup]="couponForm" (ngSubmit)="onSubmit()">
                <label class="pb-3"> ¿Tienes un cupón de membresía? <span>Ingrese el código aquí:</span></label>

                <div class="w-100 justify-content-center d-none d-md-flex">
                  <!-- codigo cupon -->
                  <div class="campo">
                    <input class="form-control form-control-lg" type="text" placeholder="Código"
                      formControlName="codigoCupon" />

                    <ng-container
                      *ngIf="couponForm.get('codigoCupon').invalid && couponForm.get('codigoCupon').touched">
                      <div *ngIf="couponForm.get('codigoCupon').errors?.required" class="text-danger">
                        Debe ingresar un código.
                      </div>
                    </ng-container>
                  </div>

                </div>

                <div class="w-100 pt-3 justify-content-center d-none d-md-flex">
                  <button class="btn btn-lg btn-pagar pink" type="submit" [ngClass]="{ disabled: !couponForm.valid }">
                    <span class="text-white"> <i class="fas fa-receipt mr-2"></i> CANJEAR</span>
                  </button>
                </div>

                <div class="row d-md-none">
                  <!-- codigo cupon -->
                  <div class="col-12 mb-2">
                    <input class="form-control form-control-lg" type="text" placeholder="Código"
                      formControlName="codigoCupon" />

                    <ng-container
                      *ngIf="couponForm.get('codigoCupon').invalid && couponForm.get('codigoCupon').touched">
                      <div *ngIf="couponForm.get('codigoCupon').errors?.required" class="text-danger">
                        Debe ingresar un código.
                      </div>
                    </ng-container>
                  </div>

                  <div class="col-12">
                    <button class="btn btn-lg btn-block btn-pagar pink" type="submit"
                      [ngClass]="{ disabled: !couponForm.valid }">
                      <span class="text-white"> <i class="fas fa-receipt mr-2"></i> CANJEAR</span>
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>

        </div>

        <div class="card-body text-center" *ngIf="loading">
          <div class="spinner-border mt-2 text-secondary" style="width: 1.5rem; height: 1.5rem" role="status"
            *ngIf="loading">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- volver a la home -->
  <div class="row">
    <div class="col-12 mt-5">
      <div class="d-flex justify-content-center">
        <a href="/" class="btn bg-light font_CinematecaBlack"><strong>Volver al home</strong></a>
      </div>
    </div>
  </div>
</div>

<form id="payment_form"></form>